import React from 'react';
import block from 'bem-cn';

import Button from 'components/Button';
import Spinner from 'components/Spinner/view/desktop';
import SVG from 'components/SVG';
import Input from 'components/Input';

import { formateNumber } from 'shared/helpers';
import parseNumberFromString from 'shared/helpers/parseNumberFromString';
import { convertBalanceToNum } from 'shared/helpers/convertBalanceToNum';

import useWithdrawalModel from '../../../../model/useWithdrawalModel';
import { useAmountTypes, userTypes } from '../../../../data';

import './Withdrawal.scss';

const b = block('withdrawal');

const Withdrawal = () => {
  const { actionProcessing, amount, changeValue, childBalance, locale, onSubmit, players, history, setAmount } =
    useWithdrawalModel();
  const { types } = useAmountTypes();

  if (actionProcessing) return <Spinner isLoading={actionProcessing} />;

  const handleAllButton = () => {
    setAmount(parseNumberFromString(convertBalanceToNum(childBalance)));
  };

  return (
    <div className={b()}>
      <div className={b('wrapper')}>
        <div className={b('top')}>
          <div className={b('header')}>{locale.withdrawal}</div>
          <div className={b('header', { small: true })}>{locale.withdrawalOfFunds}</div>
          <div className={b('user-blocks')}>
            {players.map(player => (
              <div className={b('user-block')}>
                <div className={b('user-block-title')}>{player.title}</div>
                <div className={b('user-block-wrapper')}>
                  <div className={b('user-block-left')}>
                    <SVG svgProps={{ svg: userTypes[player.role].icon }} className={b('user-block-icon')} />
                    <div className={b('user-block-info')}>
                      <span>{player.username}</span>
                      <div className={b('user-block-info-type', { role: player.role })}>
                        {userTypes[player.role].type}
                      </div>
                    </div>
                  </div>
                  <div className={b('user-block-right')}>
                    <span>{locale.balance}:</span>
                    <span>{player.balance}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className={b('amount-types')}>
            {Object.keys(types).map(type => (
              <div className={b('amount-types-item')} onClick={() => changeValue(type)}>
                {formateNumber(type)}
              </div>
            ))}
          </div>

          <div className={b('input-block')}>
            <span className={b('input-block-title')}>{locale.amount}</span>
            <div className={b('input', { type: 'amount' })}>
              <Input
                placeholder={locale.amount}
                withEye
                validState={amount > 0 ? 2 : 3}
                onChange={changeValue}
                value={amount}
                name="amount"
                withFormatting
              />
              <div className={b('all-btn')}>
                <Button callBack={handleAllButton} size="low" text={locale.all1} />
              </div>
            </div>
          </div>
        </div>
        <div className={b('bottom')}>
          <Button color="full-transparent" callBack={history.goBack} text={locale.cancel} size="low" />
          <Button callBack={onSubmit} type="submit" size="low" text={locale.withdrawal} />
        </div>
      </div>
    </div>
  );
};

export default Withdrawal;
